/**
 * @fileoverview Link Component
 * @author Matt Convente (mconvente@yext.com)
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.link');

import {usePendoId} from '/ui/components/pendo/pendo';
import {hasManaUITheme} from '/ui/design/hasManaUITheme';
import {classNames} from '/ui/lib/classnames';

import * as styles from '/ui/components/link/link.module.scss';

/**
 * @typedef {{
 *   ariaLabel?: string,
 *   children?: React.ReactNode,
 *   className?: string,
 *   context?: string,
 *   external?: boolean,
 *   fullWidth?: boolean,
 *   href?: string,
 *   id?: string,
 *   size?: string,
 *   tid?: string,
 *   pendoId?: string,
 *   icon?: React.ReactNode,
 *   darkMode?: boolean,
 *   ref?: ?,
 * }}
 */
export let LinkProps;

export const Link = /** @type {function(LinkProps) : React.ReactElement} */ (React.forwardRef(({
  ariaLabel,
  children,
  className,
  context,
  external = false,
  fullWidth = false,
  href,
  id,
  size = 'medium',
  tid,
  pendoId,
  icon,
  darkMode = false,
  ...props
}, ref) => {
  const linkStyles = classNames(
    className,
    styles.link,
    {
      [styles.linkAsButton]: !!context,
      [styles.linkSmall]: !!context && size === 'small',
      [styles.linkDefault]: context === 'default' && !hasManaUITheme(),
      [styles.linkPrimary]: context === 'primary',
      [styles.linkWarning]: context === 'warning',
      [styles.linkFullWidth]: fullWidth,
      [styles.linkDarkMode]: !context && darkMode,
      [styles.linkAsManaButton]: !!context && hasManaUITheme(),
      [styles.linkManaDefault]: context == 'default' && hasManaUITheme(),
    },
  );

  const target = external ? '_blank' : undefined;
  const rel = external ? 'noopener noreferrer' : undefined;
  const pendoTag = usePendoId('link', pendoId);

  const iconMarkup = icon
    ? (<span className={styles.iconContainer}>{icon}</span>)
    : null;

  return (
    <a
      className={linkStyles}
      id={id}
      href={href}
      tid={tid}
      data-pendo={pendoTag}
      aria-label={ariaLabel}
      target={target}
      rel={rel}
      ref={ref}
      {...props}
    >
      {iconMarkup}
      {children}
    </a>
  );
}));
